/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-fragments */
import {useMutation, useQuery} from '@apollo/client';
import cx from 'classnames';
import decodeId from 'core/libs/helpers/decodeId';
import notification from 'core/libs/helpers/notification';
import log from 'core/libs/logger';
import {useFormik} from 'formik';
import LoadingIndicator from 'modules/common/LoadingIndicator';
import PropTypes from 'prop-types';
import React, {Fragment, useState} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import Deadline from 'theme/assets/images/deadline.svg';
import * as Yup from 'yup';
import PROJECT_DEADLINE from '../../graphql/projectDeadline.graphql';
import SUBMIT_PROJECT from '../../graphql/submitProject.graphql';
import {bgFileInput, formInput, uploadLabelWidth} from './styles.scss';

const PROJECT_SIZE = 30 * 1024 * 1024;
const {PARTNER} = process.env;

const ProjectSubmission = (props) => {
  const intl = useIntl();
  const {formatMessage} = intl;
  const {
    description,
    projectFailed,
    projectId,
    hasSubscription,
    trackId,
    partner,
    userId,
  } = props;
  const [submissionType, setSubmissionType] = useState('url-repo');
  const [mutate] = useMutation(SUBMIT_PROJECT, {
    onCompleted: () => {
      submissionType === 'url-repo' &&
        notification({
          id: 'project_sent_with_success',
          type: 'success',
        });
    },
    refetchQueries: ['allProjectSubmissions'],
  });
  const formik = useFormik({
    initialValues: {
      track: '',
      project: '',
      repoUrl: '',
      zipFile: '',
      note: '',
    },
    validationSchema: () =>
      Yup.object().shape({
        repoUrl:
          submissionType === 'url-repo'
            ? Yup.string().required(formatMessage({id: 'github_repo_required'}))
            : Yup.string(),
        zipFile:
          submissionType !== 'url-repo'
            ? Yup.mixed()
                .required(formatMessage({id: 'file_is_required'}))
                .test(
                  'fileSize',
                  formatMessage({id: 'file_size_too_large'}),
                  (value) => value && value.size <= PROJECT_SIZE,
                )
            : Yup.mixed(),
      }),
    onSubmit: ({repoUrl, zipFile, note}, actions) => {
      actions.setSubmitting(true);
      mutate({
        variables: {
          input: {
            track: trackId,
            project: projectId,
            repoUrl: submissionType === 'url-repo' ? repoUrl : null,
            zipFile: submissionType !== 'url-repo' ? zipFile : null,
            note,
          },
        },
      })
        .then((response) => {
          if (response && submissionType !== 'url-repo') {
            if (response.data.projectSubmissionCreate.id) {
              notification({
                id: 'project_sent_with_success',
                type: 'success',
              });
            }
            if (response.data.projectSubmissionCreate.errors.length) {
              log('Error while submitting project as a file', {
                errorMessage:
                  response.data.projectSubmissionCreate.errors[0].message,
                currentUrl:
                  typeof window !== 'undefined' && window.location.href,
              });
              notification({
                message:
                  response.data.projectSubmissionCreate.errors[0].message,
              });
            }
          }
          actions.resetForm(false);
        })
        .catch((e) => {
          const errors = e.graphQLErrors.map((error) => error.message);
          log('Error while submitting project as a url repo', {
            errors,
            currentUrl: typeof window !== 'undefined' && window.location.href,
          });
          if (errors.length) {
            notification({
              message: JSON.stringify(errors[0]).replace(/['"]+/g, ''),
            });
          }
          actions.setSubmitting(false);
        });
    },
  });
  const degreeId = decodeId(trackId);
  const {data, loading, error} = useQuery(PROJECT_DEADLINE, {
    variables: {
      id: projectId,
      partner,
      userId,
      degreeId,
    },
    skip: !userId,
  });
  if (loading) return <LoadingIndicator />;
  if (error) {
    const errorMessage = error.message;
    log('Error while project deadline fetching', {
      errorMessage,
      currentUrl: typeof window !== 'undefined' && window.location.href,
    });
    notification({message: errorMessage});
  }
  /* const daysLeftUntilDeadline =
    data && data.project && data.project.daysLeftUntilDeadline; */
  const daysLeftUntilDeadline = 120;
  return (
    <div
      className={cx('pv4 tr', {
        ph4: projectFailed,
        ph5: !projectFailed,
      })}
    >
      {daysLeftUntilDeadline >= 1 ? (
        <Fragment>
          {projectFailed && (
            <Fragment>
              <div className="ba b--black-10" />
              <h4 className="blue mv4">
                - <FormattedMessage id="re_submit_project" />
              </h4>
            </Fragment>
          )}
          {/* <div className="flex">
            <img src={Deadline} height="40" width="40" alt="" />
            <div className="ph3">
              <h3 className="pb1">
                <FormattedMessage id="project_deadline" />:
              </h3>
              <span>
                {daysLeftUntilDeadline} <FormattedMessage id="day" />
              </span>
            </div>
          </div> */}
        </Fragment>
      ) : (
        <Fragment>
          {projectFailed && <div className="ba b--black-10" />}
          <h4
            className={cx('red', {
              mt4: projectFailed,
            })}
          >
            <FormattedMessage id="subsmission_deadline_has_been_passed" />
          </h4>
        </Fragment>
      )}
      <p
        className="pv4"
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />

      <div className="pv4">
        <div className="flex items-center">
          <input
            aria-label="Submission type url repo"
            type="radio"
            name="submission-type"
            value="url-repo"
            onChange={(e) => {
              setSubmissionType(e.target.value);
            }}
            checked={submissionType === 'url-repo'}
          />
          &nbsp;
          <p className="gray">
            <FormattedMessage id="enter_project_url" />
          </p>
          <div className="ph2" />
          <input
            aria-label="Submission type zip file"
            type="radio"
            name="submission-type"
            value="zip-file"
            onChange={(e) => {
              setSubmissionType(e.target.value);
            }}
            checked={submissionType === 'zip-file'}
          />
          &nbsp;
          <p className="gray">
            <FormattedMessage id="upload_project_format" />
          </p>
        </div>
        <div className="pv3">
          <form onSubmit={formik.handleSubmit}>
            {submissionType === 'url-repo' ? (
              <>
                <input
                  aria-label="Repo url"
                  placeholder={formatMessage({id: 'enter_project_url'})}
                  type="text"
                  name="repoUrl"
                  className="pa2 dark-gray ba b--light-gray bw1 br2 mt3"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.repoUrl}
                />
                {formik.touched.repoUrl && formik.errors.repoUrl && (
                  <div className="pv1">
                    <span className="red">{formik.errors.repoUrl}</span>
                  </div>
                )}{' '}
              </>
            ) : (
              <>
                <div
                  className={`pv1 ${bgFileInput} w-100 br2 ba b--transparent`}
                >
                  <div className="relative flex flex-row-ns flex-column pr1">
                    <input
                      name="zipFile"
                      type="file"
                      onChange={(event) => {
                        formik.setFieldValue(
                          'zipFile',
                          event.currentTarget.files[0],
                        );
                        formik.setFieldValue(
                          'uploadFilePath',
                          event.target.value
                            .replace(/\\/g, '')
                            .replace(/C:fakepath/g, ''),
                        );
                      }}
                      className="absolute o-0"
                      accept=".zip, .rar"
                    />
                    <label
                      className={`mt1 ${uploadLabelWidth} pa2 tc bg-blue white ba b--moon-gray br2`}
                    >
                      <FormattedMessage id="upload_project" />
                    </label>
                    <input
                      name="uploadFilePath"
                      onBlur={formik.handleBlur}
                      value={formik.values.uploadFilePath}
                      type="text"
                      className={`relative ba b--transparent w-100 ${formInput}`}
                      placeholder={formatMessage({
                        id: 'no_file_chosen',
                      })}
                      disabled
                    />
                  </div>
                </div>
                {!formik.dirty && formik.errors.zipFile && (
                  <div className="pv1">
                    <span className="red">{formik.errors.zipFile}</span>
                  </div>
                )}
              </>
            )}
            <div className="pv3">
              <textarea
                aria-label="note"
                placeholder={formatMessage({
                  id: 'write_note_for_your_mentor',
                })}
                type="text"
                name="note"
                className="pa2 dark-gray ba b--light-gray bw1 br2 mt3 w-50-ns"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.note}
              />
            </div>
            <div className="flex items-center pv3">
              <button
                aria-label="Send project"
                className={cx(
                  'fw6 white dib pv2 ph3 f6 br2 b--transparent lh-copy',
                  {
                    'bg-green-light bg-animate hover-bg-green pointer': !formik.isSubmitting,
                    'bg-light-gray': formik.isSubmitting,
                  },
                )}
                type="submit"
                disabled={formik.isSubmitting}
              >
                <FormattedMessage id="send_project" />
              </button>
              <p className="blue pr3">
                <FormattedMessage id="project_submission_note" />
              </p>
            </div>
          </form>
        </div>
      </div>
      {/* ) : (
        <div className="pv4">
          <h4 className="blue">
            <FormattedMessage id="users_without_subscription_cannot_submit" />
          </h4>
        </div>
      )} */}
    </div>
  );
};

ProjectSubmission.propTypes = {
  description: PropTypes.string.isRequired,
  projectFailed: PropTypes.bool,
  projectId: PropTypes.string.isRequired,
  hasSubscription: PropTypes.bool.isRequired,
  trackId: PropTypes.string.isRequired,
  partner: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
};

export default ProjectSubmission;
